import { render, staticRenderFns } from "./setCameraType.vue?vue&type=template&id=512e6b15&scoped=true"
import script from "./setCameraType.vue?vue&type=script&lang=js"
export * from "./setCameraType.vue?vue&type=script&lang=js"
import style0 from "./setCameraType.vue?vue&type=style&index=0&id=512e6b15&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e6b15",
  null
  
)

export default component.exports